import httpClient from '@/api/http-client';

const endpoint = 'api/banned-ip-addresses';

const bannedIpAddressesService = {
  getAddresses: (params) => httpClient.get(endpoint, { params }),

  create: (address) => httpClient.post(`${endpoint}`, address),
};

export default bannedIpAddressesService;
